import { atomFamily, type SerializableParam } from 'recoil'

export interface IDialogState<T> {
  open: boolean
  data?: T
}

export const dialogFamily = atomFamily<IDialogState<unknown>, SerializableParam>({
  key: 'dialogFamily',
  default: {
    open: false,
    data: undefined,
  },
})
